import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';
import MuvikaService from '../services/muvika';
import TR from './../Trans';
import environmentStore from './environment';
import messageStore from './message';
import newsStore from './news';
import { Capacitor } from '@capacitor/core';
import homeStore from './home';
import captchaStore from './captcha';
import { subscribeWithSelector } from 'zustand/middleware';
import muvikaAttrs from './../attrs'

const initialState = {
  isSet: false,
  timeDiff: 0,
  verifiedUsername: null,
  account: null,
  urls: null,
  verificationCode: null,
  isAccountPinVerified: false,
  isAccountPinSet: false,
  isAccountLinkSent: false,
  isAccountLinkVerified: false,
  isRegistered: false,
  accountPin: "",
  shopVerificationCode: null,
  isForgottenPasswordChanged: false,
  isWaiting: false,
  isSaveable: false
};

const accountStore = create(subscribeWithSelector((set, get) => ({
  ...initialState,
  reset: () => {
    set(initialState);
  },
  setSaveable: (isSaveable) => {
    set({ isSaveable: isSaveable });
  },
  clearAll: () => {
    set({
      isSet: false,
      verifiedUsername: null,
      account: null,
      verificationCode: null,
      isAccountPinVerified: false,
      isAccountPinSet: false,
      isAccountLinkSent: false,
      isAccountLinkVerified: false,
      isRegistered: false,
      accountPin: "",
      isForgottenPasswordChanged: false,
      isWaiting: false
    });
  },
  clearAccount: () => {
    set({ account: null });
  },
  clearVerifications: () => {
    set({
      verifiedUsername: null,
      verificationCode: null,
      isAccountPinVerified: false,
      isAccountPinSet: false,
      isAccountLinkSent: false,
      isAccountLinkVerified: false,
      isRegistered: false,
      accountPin: "",
      isForgottenPasswordChanged: false
    });
  },
  getAccount: (sessionToken) => {
    MuvikaService.getAccount(sessionToken)
      .then(function (res) {
        //console.log(res)
        if (res.data.error) {
          set({ isSet: false });
          messageStore.getState().setError(sessionToken, res.data.error.code, res.data.error.details.length > 0 ? res.data.error.details : res.data.error.string);
        } else {
          let account = res.data.data.account;
          let urls = res.data.data.urls;
          let language = account.language.toLowerCase();
          TR.setLanguage(language);
          localStorage.setItem(muvikaAttrs.service+"-session-language", JSON.stringify(language));
          document.title = TR.ww_page_title;
          environmentStore.getState().getEnvironment(sessionToken);
          let timeInfo = res.data.data.time_info;
          let serverDate = new Date(timeInfo.server_time);
          let dateNow = new Date();
          let diff = serverDate.getTime() - dateNow.getTime();
          let minutesDiff = (diff / (1000 * 60)).toFixed(1);
          console.log("diff: " + minutesDiff);
          //account.subscription.order_info.popup_msg="Pöö";
          set({ isSet: true, account: { ...account }, urls: urls, timeDiff: minutesDiff });
        }
      })
      .catch(function () { });
  },
  setAccount: (sessionToken, account) => {
    set({ isWaiting: true });
    MuvikaService.setAccount(sessionToken, account)
      .then(function (res) {
        if (res.data.error) {
          set({ isWaiting: false });
          messageStore.getState().setError(sessionToken, res.data.error.code, res.data.error.details.length > 0 ? res.data.error.details : res.data.error.string);
        } else {
          let accountNew = { ...account };
          let language = accountNew.language.toLowerCase();
          TR.setLanguage(language);
          localStorage.setItem(muvikaAttrs.service+"-session-language", JSON.stringify(language));
          document.title = TR.ww_page_title;
          environmentStore.getState().getEnvironment(sessionToken);
          set({ isSet: true, account: accountNew, isWaiting: false });
          messageStore.getState().setMessage(sessionToken, TR.cm_saved);
          newsStore.getState().getNews(sessionToken, 25);
          homeStore.getState().getTrendingTracks(sessionToken, 50);
          homeStore.getState().getPublicPlaylists(sessionToken);
        }
      })
      .catch(function () { });
  },
  createAccountLink: (sessionToken, email, reason) => {
    MuvikaService.createAccountLink(sessionToken, email, reason)
      .then(function (res) {
        //console.log(res);
        if (res.data.error) {
          messageStore.getState().setError(sessionToken, res.data.error.code, res.data.error.details.length > 0 ? res.data.error.details : res.data.error.string);
        } else {
          set({ isAccountLinkSent: true });
        }
      })
      .catch(function () { });
  },
  clearShopVerificationCode: () => {
    set({ shopVerificationCode: null });
  },
  getShopVerificationCode: (sessionToken, email) => {
    MuvikaService.createAccountLink(sessionToken, email, "one_time_login")
      .then(function (res) {
        //console.log(res);
        if (res.data.error) {
          messageStore.getState().setError(sessionToken, res.data.error.code, res.data.error.details.length > 0 ? res.data.error.details : res.data.error.string);
        } else {
          set({ shopVerificationCode: res.data.data.code });
        }
      })
      .catch(function () { });
  },
  changePassword: (sessionToken, email, oldPassword, newPassword) => {
    MuvikaService.changePassword(sessionToken, email, oldPassword, newPassword)
      .then(function (res) {
        //console.log(res);
        if (res.data.error) {
          messageStore.getState().setError(sessionToken, res.data.error.code, res.data.error.details.length > 0 ? res.data.error.details : res.data.error.string);
        } else {
          messageStore.getState().setMessage(sessionToken, TR.ww_password_changed);
        }
      })
      .catch(function () { });
  },
  changeUsername: (sessionToken, newUsername, password, verificationCode) => {
    MuvikaService.changeUsername(sessionToken, newUsername, password, verificationCode)
      .then(function (res) {
        //console.log(res);
        if (res.data.error) {
          messageStore.getState().setError(sessionToken, res.data.error.code, res.data.error.details.length > 0 ? res.data.error.details : res.data.error.string);
        } else {
          messageStore.getState().setMessage(sessionToken, TR.ww_username_hanged);
          set({ isAccountPinVerified: false, isAccountPinSet: false, verificationCode: "" });
          get().getAccount(sessionToken);
        }
      })
      .catch(function () { });
  },
  changeForgottenPassword: (sessionToken, email, newPassword, verificationCode) => {
    MuvikaService.changeForgottenPassword(sessionToken, email, newPassword, verificationCode)
      .then(function (res) {
        //console.log(res);
        if (res.data.error) {
          messageStore.getState().setError(sessionToken, res.data.error.code, res.data.error.details.length > 0 ? res.data.error.details : res.data.error.string);
        } else {
          messageStore.getState().setMessage(sessionToken, TR.ww_password_changed);
          set({ isForgottenPasswordChanged: true });
        }
      })
      .catch(function () { });
  },
  verifyAccountLink: (sessionToken, verificationCode) => {
    MuvikaService.verifyAccountLink(sessionToken, verificationCode)
      .then(function (res) {
        //console.log(res);
        if (res.data.error) {
          messageStore.getState().setError(sessionToken, res.data.error.code, res.data.error.details.length > 0 ? res.data.error.details : res.data.error.string);
        } else {
          set({ verifiedUsername: res.data.data.username });
        }
      })
      .catch(function () { });
  },
  createAccountPin: (sessionToken, email, reason, captchaId = null, captchaCode = null, password = null, username = null, source = null, license = null) => {
    set({ isWaiting: true });
    MuvikaService.createAccountPin(sessionToken, email, reason, captchaId, captchaCode, password, username, source, license)
      .then(function (res) {
        //console.log(res);
        if (res.data.error) {
          get().clearVerifications();
          captchaStore.getState().createCaptcha(sessionToken);
          set({ isAccountPinSet: false, isWaiting: false });
          messageStore.getState().setError(sessionToken, res.data.error.code, res.data.error.details.length > 0 ? res.data.error.details : res.data.error.string);
        } else {
          captchaStore.getState().reset();
          set({ isAccountPinSet: true, isWaiting: false });
        }
      })
      .catch(function () { });
  },
  verifyPin: (sessionToken, pin, email, reason) => {
    MuvikaService.verifyAccountPin(sessionToken, pin, email, reason)
      .then(function (res) {
        //console.log(res);
        if (res.data.error) {
          messageStore.getState().setError(sessionToken, res.data.error.code, res.data.error.details.length > 0 ? res.data.error.details : res.data.error.string);
        } else {
          set({ isAccountPinVerified: true, verificationCode: res.data.data.code });
        }
      })
      .catch(function () { });
  },
  verifyPinChangeUsername: (sessionToken, pin, email, reason, newUsername, password) => {
    MuvikaService.verifyAccountPin(sessionToken, pin, email, reason)
      .then(function (res) {
        //console.log(res);
        if (res.data.error) {
          messageStore.getState().setError(sessionToken, res.data.error.code, res.data.error.details.length > 0 ? res.data.error.details : res.data.error.string);
        } else {
          get().changeUsername(sessionToken, newUsername, password, res.data.data.code);
        }
      })
      .catch(function () { });
  },
  createAccount: (sessionToken, account, verificationCode) => {
    set({isWaiting: true})
    MuvikaService.createAccount(sessionToken, account, verificationCode)
      .then(function (res) {
        //console.log(res);
        if (res.data.error) {
          set({ isSet: false, isWaiting: false });
          messageStore.getState().setError(sessionToken, res.data.error.code, res.data.error.details.length > 0 ? res.data.error.details : res.data.error.string);
        } else {
          messageStore.getState().setMessage(sessionToken, TR.ww_account_created);
          let account = res.data.data;
          TR.setLanguage(account.language.toLowerCase());
          document.title = TR.ww_page_title;
          environmentStore.getState().getEnvironment(sessionToken);
          set({ isSet: true, account: { ...account }, isRegistered: true, isWaiting: false });
          if (!Capacitor.isNativePlatform() && muvikaAttrs.isProd) {
            window.gtag('config', muvikaAttrs.gaID);
            window.gtag('event', 'conversion', {'send_to': muvikaAttrs.gaIDConv, 'swname': 'muvikaweb'});
          }
        }
      })
      .catch(function () { set({isWaiting: false})});
  },
  verifyCurrentPassword: (sessionToken, username, newUsername, password) => {
    get().createAccountPin(sessionToken, newUsername, "change_username", null, null, password, username);
  }
})));

export default accountStore;